import {isCapacityRetryState,type CapacityRetryState,type CodexNotification} from '@reados/contracts';
import type {CapacityRetryPresentation} from './components/CapacityRetryNotice';

/** The API's monotonic conversation revision arbitrates live events and history
 * reads. An older reconnect response cannot reopen a resolved capacity error. */
export function mergeCapacityRetryState(current:CapacityRetryState|null,incoming:unknown,ownerThreadId:string,nativeThreadId?:string):CapacityRetryState|null {
  const previous=current?.ownerThreadId===ownerThreadId?current:null;
  if(!isCapacityRetryState(incoming)||incoming.ownerThreadId!==ownerThreadId||nativeThreadId&&incoming.threadId!==nativeThreadId)return previous;
  if(previous&&previous.revision>=incoming.revision)return previous;
  return incoming;
}

export function capacityRetryFromEvent(event:CodexNotification):CapacityRetryState|null {
  return event.method==='reados/capacityRetry'&&isCapacityRetryState(event.params)?event.params:null;
}

export function capacityRetryIsActive(state:CapacityRetryState|null):boolean {
  return state?.status==='waiting'||state?.status==='retrying';
}

export function capacityRetryPresentation(state:CapacityRetryState|null,ownerThreadId:string|null):CapacityRetryPresentation|null {
  if(!state||state.ownerThreadId!==ownerThreadId||!['waiting','retrying','exhausted'].includes(state.status))return null;
  return {id:state.cycleId,nativeThreadId:state.threadId,turnId:state.turnId,phase:state.status as CapacityRetryPresentation['phase'],retryCount:state.retryCount,maxRetries:state.maxRetries,...(state.message?{message:state.message}:{})};
}
